export default __webpack_public_path__ + "static/media/YouTube.9d4b5bee.svg";